export const extractVimeoId = (rawInput = "") => {
  if (!rawInput) return null;

  // Allow users to paste the full iframe snippet by picking the src attribute.
  const iframeMatch = rawInput.match(/\ssrc=["']([^"']+)["']/i);
  let cleanedInput = iframeMatch ? iframeMatch[1] : rawInput.trim();

  // Decode minimal HTML entities that appear in copied iframe embeds.
  cleanedInput = cleanedInput.replace(/&amp;/g, "&");

  const regex = /vimeo\.com\/(?:.*\/)?(\d+)(?:\?h=([\w\d]+))?/;
  const match = cleanedInput.match(regex);

  if (!match) return null;

  const videoId = match[1];
  const hash = match[2];

  // Always return the canonical embed URL so the backend receives a clean link.
  const baseUrl = `https://player.vimeo.com/video/${videoId}`;
  return hash ? `${baseUrl}?h=${hash}` : baseUrl;
};
